import { Badge, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  badge: {
    height: 16,
    margin: "0px",
    minWidth: 16,
    [theme.breakpoints.up("md")]: {
      height: 20,
      margin: "4px",
      minWidth: 20
    }
  }
}));

interface IOwnProps {
  children: React.ReactNode;
  count: number;
}

const OpenTasks = ({ children, count }: IOwnProps) => {
  const classes = useStyles();
  return (
    <Badge badgeContent={count} color="secondary" classes={{ badge: classes.badge }}>
      {children}
    </Badge>
  );
};

export default React.memo(OpenTasks);
